import { combineReducers } from 'redux';

import * as authentication from './authentication';
import * as user from './user';
import * as role from './role';
import * as unit from './unit';
import * as color from './color';
import * as factory from './factory';
import * as rack from './rack';
import * as customer from './customer';
import * as vendor from './vendor';
import * as style from './style';
import * as fabric from './fabric';
import * as accessory from './accessory';
import * as product from './product';
import * as fabricInventory from './fabric_inventory';
import * as accessoryInventory from './accessory_inventory';
import * as jobcharts from './jobcharts';
import * as samples from './samples';
import * as timeActions from './time_actions';
import * as issueReceive from './issue_receive';
import * as renukapo from './renukapo';
import * as storeInward from './store_inward';
import * as storeOutward from './store_outward';
import * as qualityCheck from './quality_check';
import * as dailyCompletion from './daily_completion';
import * as costSheet from './cost_sheet';
import * as workers from './workers';

export default combineReducers({
  ...authentication,
  ...user,
  ...role,
  ...unit,
  ...color,
  ...factory,
  ...rack,
  ...customer,
  ...vendor,
  ...style,
  ...fabric,
  ...accessory,
  ...product,
  ...fabricInventory,
  ...accessoryInventory,
  ...jobcharts,
  ...samples,
  ...timeActions,
  ...issueReceive,
  ...renukapo,
  ...storeInward,
  ...storeOutward,
  ...qualityCheck,
  ...dailyCompletion,
  ...costSheet,
  ...workers,
});
